import styled from "styled-components";
import AddFilterIcon from "../icons/AddFilterIcon";

export const InfoIconContainer = styled.div`
  .icon-action {
    opacity: 0;
    visibility: hidden;
    transition:
      opacity 0.15s ease-in-out,
      visibility 0.15s ease-in-out;
  }
  &:hover .icon-action {
    opacity: 1;
    visibility: visible;
  }
`;

const ActionableField = ({ children, showAddFilter = false, onClickAddFilter = () => {} }) => {
  return (
    <InfoIconContainer className={"flex items-center w-full"}>
      <div className="flex-1 min-w-0">{children}</div>
      {showAddFilter && (
        <AddFilterIcon
          className={
            "icon-action w-4 shrink-0 text-gray-400 hover:text-blue-600 cursor-pointer ml-1"
          }
          onClick={onClickAddFilter}
        />
      )}
    </InfoIconContainer>
  );
};

export default ActionableField;
